import { BuildActionNames } from '@/helpers/utils';

export const actionTypes = BuildActionNames('config', ['BEGIN_API_CALL', 'END_API_CALL']);

export interface BeginApiCallAction {
  type: typeof actionTypes.BEGIN_API_CALL;
}

export interface EndApiCallAction {
  type: typeof actionTypes.END_API_CALL;
}

export type UIState = {
  theme: string;
  apiCallsInProgress: number;
};

export type ConfigState = {
  ui: UIState;
};

export type ConfigAction = BeginApiCallAction | EndApiCallAction;
